<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-10">
                <h4 class="fs-title">REGISTRATION DETAIL REQUEST {{schoolname}}</h4>
            </div>
        </div>
        <div class="row card">
            <div class="col-lg-12">
                <div class="row justify-content-center">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #RegistrationForm="ngForm" id="RegistrationForm" class="msform">
                            <div class="row mt-2" style="display: none;">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="chkBoard{{i}}" name="chkBoard{{i}}" />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="chkmedium{{i}}" name="chkmedium{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Institute Type</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="chkinstitute{{i}}" name="chkinstitute{{i}}" [value]="ins.value"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="chksection{{i}}" name="chksection{{i}}"
                                            (change)="fillCourse()" />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>University</b><span class="text-danger">*</span></label> <br>
                                    <label *ngFor="let b of boards; let i=index">
                                        <input type="checkbox" id="oldchkBoard{{i}}" name="oldchkBoard{{i}}" />
                                        &nbsp;&nbsp; {{b.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Medium</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let m of mediums; let i=index">
                                        <input type="checkbox" id="oldchkmedium{{i}}" name="oldchkmedium{{i}}"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{m.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Institute Type</b><span class="text-danger">*</span></label><br>
                                    <label *ngFor="let ins of institutetypes; let i=index">
                                        <input type="checkbox" id="oldchkinstitute{{i}}" name="oldchkinstitute{{i}}" [value]="ins.value"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{ins.text}} &nbsp;&nbsp;
                                    </label>

                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Faculty</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of sections; let i=index">
                                        <input type="checkbox" id="oldchksection{{i}}" name="oldchksection{{i}}"
                                            (change)="fillOldCourse()" />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2" style="display: none;"
                                *ngIf="standards != undefined && standards.length > 0">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of standards; let i=index">
                                        <input type="checkbox" id="chkStd{{i}}" name="chkStd{{i}}"
                                            (change)="manageRegDoc(i,s.text,s.MediumID,s.sectionID,s.value);" checked />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="row mt-2" style="display: none;"
                                *ngIf="oldstandards != undefined && oldstandards.length > 0">
                                <div class="form-group col-lg-10 col-md-12 col-12">
                                    <label><b>Course</b><span class="text-danger">*</span></label> <br />
                                    <label *ngFor="let s of standards; let i=index">
                                        <input type="checkbox" id="oldchkStd{{i}}" name="oldchkStd{{i}}"
                                            (change)="manageOldRegDoc(i,s.text,s.MediumID,s.sectionID,s.value);"
                                            checked />
                                        &nbsp;&nbsp; {{s.text}} &nbsp;&nbsp;
                                    </label>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2">
                                <h4>Trustee Details</h4>
                                <hr style="margin: 0;">

                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Trustee's name</th>
                                                        <th>Trustee's address</th>
                                                        <th>Trustee's Contact / Mobile no.</th>
                                                        <th>Trustee's mail id</th>
                                                        <!-- <th>ACTION</th> -->
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of OldTrusteeDetail;let i = index">
                                                    <td>{{t.TrusteeName}}</td>
                                                    <td>{{t.TrusteeAddress}}</td>
                                                    <td>{{t.TrusteeMobileNo}}</td>
                                                    <td>{{t.TrusteeMailID}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <hr>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Trustee's name</th>
                                                        <th>Trustee's address</th>
                                                        <th>Trustee's Contact / Mobile no.</th>
                                                        <th>Trustee's mail id</th>
                                                        <!-- <th>ACTION</th> -->
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of TrusteeDetail;let i = index">
                                                    <td>{{t.TrusteeName}}</td>
                                                    <td>{{t.TrusteeAddress}}</td>
                                                    <td>{{t.TrusteeMobileNo}}</td>
                                                    <td>{{t.TrusteeMailID}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Employee Details</h4>
                                <hr style="margin: 0;">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>Employee type</th>
                                                        <th>No. of permanent employee</th>
                                                        <th>No. of Ad-Hoc employee</th>
                                                        <th>Total permanent employee's salary</th>
                                                        <th>Total Ad-Hoc employee's salary</th>
                                                        <!-- <th>Action</th> -->
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of OldEmployeeDetail;let i = index">
                                                    <td>{{t.EmployeeType}}</td>
                                                    <td>{{t.NoOfPermanentEmployee}}</td>
                                                    <td>{{t.NoOfAdhocEmployee}}</td>
                                                    <td>{{t.TotalPermanentSalary}}</td>
                                                    <td>{{t.TotalAdhocSalary}}</td>

                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Employee type</th>
                                                        <th>No. of permanent employee</th>
                                                        <th>No. of Ad-Hoc employee</th>
                                                        <th>Total permanent employee's salary</th>
                                                        <th>Total Ad-Hoc employee's salary</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of EmployeeDetail;let i = index">
                                                    <td>{{t.EmployeeType}}</td>
                                                    <td>{{t.NoOfPermanentEmployee}}</td>
                                                    <td>{{t.NoOfAdhocEmployee}}</td>
                                                    <td>{{t.TotalPermanentSalary}}</td>
                                                    <td>{{t.TotalAdhocSalary}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark  bg-custom  p-2 mt-2">
                                <h4>Employee Qualification Details</h4>
                                <hr style="margin: 0;">

                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Qualification type</th>
                                                        <th>No. of employees</th>
                                                        <!-- <th>Action</th> -->
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of OldEmployeeQualificationDetail;let i = index">
                                                    <td>{{t.Qualification}}</td>
                                                    <td>{{t.NoofEmployee}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Qualification type</th>
                                                        <th>No. of employees</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of EmployeeQualificationDetail;let i = index">
                                                    <td>{{t.Qualification}}</td>
                                                    <td>{{t.NoofEmployee}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <h4>Principal Details</h4>
                                <hr style="margin: 0;">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Designation</th>
                                                        <th>Principal's name</th>
                                                        <th>Principal's mobile no.</th>
                                                        <th>Principal's mail id</th>
                                                        <!-- <th>Action</th> -->
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of OldPrincipalDetail;let j = index">
                                                    <td>{{t.PrinDesignation}}</td>
                                                    <td>{{t.PrincipalName}}</td>
                                                    <td>{{t.PrincipalMobileNo}}</td>
                                                    <td>{{t.PrincipalMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <div class="table-responsive">
                                            <table class="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th>Designation</th>
                                                        <th>Principal's name</th>
                                                        <th>Principal's mobile no.</th>
                                                        <th>Principal's mail id</th>
                                                    </tr>
                                                </thead>
                                                <tr *ngFor="let t of PrincipalDetail;let j = index">
                                                    <td>{{t.PrinDesignation}}</td>
                                                    <td>{{t.PrincipalName}}</td>
                                                    <td>{{t.PrincipalMobileNo}}</td>
                                                    <td>{{t.PrincipalMailID}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-lg-6 col-md-6 col-6">
                                    <h5 style="color:green">Existing Data</h5>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of authorized person who remained present in submitted
                                                        affidevit</th>
                                                    <th>Designation</th>
                                                    <th>Contact / mobile no.</th>
                                                    <th>Whatsapp mobile no.</th>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <td>{{data.OldAuthorizedPerson}}</td>
                                                <td>{{data.OldDesignation}}</td>
                                                <td>{{data.OldMobileNo}}</td>
                                                <td>{{data.OldWhatsAppNo}}</td>

                                            </tr>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-6">
                                    <h5 style="color:#e03636">Requested Data</h5>
                                    <div class="table-responsive">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of authorized person who remained present in submitted
                                                        affidevit</th>
                                                    <th>Designation</th>
                                                    <th>Contact / mobile no.</th>
                                                    <th>Whatsapp mobile no.</th>
                                                </tr>
                                            </thead>
                                            <tr>
                                                <td>{{data.AuthorizedPerson}}</td>
                                                <td>{{data.Designation}}</td>
                                                <td>{{data.MobileNo}}</td>
                                                <td>{{data.WhatsAppNo}}</td>

                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="border border-dark bg-custom p-2 mt-2">
                                <div class="form-group row mt-4">
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:green">Existing Data</h5>
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Course (Year)</th>
                                                    <th>Divison - Student Count</th>
                                                </tr>
                                            </thead>
                                            <tr *ngFor="let s of OldstandardList; let i=index">
                                                <td>
                                                    <label><b>{{s.text}}</b>
                                                    </label>
                                                    <input type="hidden" class="form-control" ngModel
                                                        name="oldstd{{i}}_{{i}}" id="oldstd{{i}}_{{i}}" numbersOnly
                                                        maxlength="2" placeholder="Enter no. of division"
                                                        (keyup)="oldfillDiv(s.value,i,s.year)">
                                                </td>
                                                <td id="olddivlist{{s.value}}_{{i}}_{{s.year}}">

                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-6">
                                        <h5 style="color:#e03636">Requested Data</h5>
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Course (Year)</th>
                                                    <th>Divison - Student Count</th>
                                                </tr>
                                            </thead>

                                            <tr *ngFor="let s of standardList; let i=index">
                                                <td>
                                                    <label><b>{{s.text}}</b>
                                                    </label>
                                                    <input type="hidden" class="form-control" ngModel name="std{{i}}_{{i}}"
                                                        id="std{{i}}_{{i}}" numbersOnly maxlength="2"
                                                        placeholder="Enter no. of division" (keyup)="fillDiv(s.value,i,s.year)">
                                                </td>
                                                <td id="divlist{{s.value}}_{{i}}_{{s.year}}">
        
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                </div>
                            </div>

                            <div class="row mt-2 p-2">
                                <button class="btn btn-danger" type="button" (click)="redirectToList()"
                                    style="margin: 5px;">Cancel</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>